module.exports = __webpack_public_path__ + "static/media/000000b.15619ad7.JPG";